module.exports = __webpack_public_path__ + "static/img/userLeft.de6b353.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/userLeft.png
// module id = mRm2
// module chunks = 1